/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";

class Event202302_springSale extends Component {
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };

  render() {
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="event_head">
          <h3>봄맞이 빅세일 이벤트</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <img
              src={
                imgUrl + "/img/event/event20230223_springsale/spring_sale.png"
              }
            />
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202302_springSale));
